import { ErrorHandler, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BusinessFinderService } from './business-finder.service';
import { FlyingClubResult } from '../models/flying-club-result.model';
import { LatLon } from '../../util/geodesy/latlon';
import { BoundingBox } from '../../util/geodesy/bounding-box';

/**
 * HTTP service for the Flying Club Finder. Calls the AirportsAPI `~/flying-clubs` endpoint. Category
 * facet filtering (Membership / Benefits / Flying / AOPA Network / ...) is applied client-side in
 * {@link SearchPageComponent}; this service performs only the location/state/keyword query.
 */
@Injectable({
  providedIn: 'root'
})
export class FlyingClubsService extends BusinessFinderService<FlyingClubResult> {

  protected readonly endpoint = 'flying-clubs';

  constructor(http: HttpClient, errorHandler: ErrorHandler) {
    super(http, errorHandler);
  }

  protected parse(data: any): FlyingClubResult {
    return FlyingClubResult.parse(data);
  }

  getFlyingClubsByLatLon(latlon: LatLon, radius: number): Promise<FlyingClubResult[]> {
    return this.getByLatLon(latlon, radius);
  }

  getFlyingClubsByBoundingBox(bounds: BoundingBox): Promise<FlyingClubResult[]> {
    return this.getByBoundingBox(bounds);
  }

  getFlyingClubsByState(state: string): Promise<FlyingClubResult[]> {
    return this.getByState(state);
  }

  getFlyingClubsBySearchTerm(term: string): Promise<FlyingClubResult[]> {
    return this.getBySearchTerm(term);
  }
}
